import { OverlayModule } from '@angular/cdk/overlay';
import { SubmenuDirectionDirective } from '../../shared/directives/submenu-direction.directive';
import { CommonModule } from '@angular/common';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { SharedModule } from 'src/app/shared/shared.module';
import { ProjectsEffects } from './core/projects.effects';
import { reducer } from './core/projects.reducer';
import { ProjectsRoutingModule } from './projects-routing.module';
import { ProjectsWrapperComponent } from './wrapper/projects-wrapper.component';
import { ProjectsPageComponent } from './pages/projects-page/screen/projects-page.component';
import { ProjectCardComponent } from './pages/projects-page/components/project-card/project-card.component';
import { EditProjectDetailsComponent } from './pages/projects-page/components/edit-project-details/edit-project-details.component';
import { IssuesSummaryComponent } from './pages/projects-page/components/issues-summary/issues-summary.component';
import { ClaimsSummaryComponent } from './pages/projects-page/components/claims-summary/claims-summary.component';
import { OffsiteTestsSummaryComponent } from './pages/projects-page/components/offsite-tests-summary/offsite-tests-summary.component';
import { StatusSummaryComponent } from './pages/projects-page/components/status-summary/status-summary.component';
import { ContractProgressCardComponent } from './pages/projects-page/components/progress-card/contract-progress-card.component';
import { ProjectDetailsScreenComponent } from './pages/projects-details-page/screen/project-details-screen.component';
import { CreateDailyReportComponent } from './components/create-daily-report/create-daily-report.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  StatusSiteFilterComponent,
} from './pages/projects-details-page/components/filters/status-site-filter/status-site-filter.component';
import { DateFilterComponent } from './pages/projects-details-page/components/filters/date-filter/date-filter.component';
import {
  PayappDateFilterComponent,
} from './pages/projects-details-page/components/filters/payapp-date-filter/payapp-date-filter.component';
import {
  PayappMultiFilterComponent,
} from './pages/projects-details-page/components/filters/payapp-multi-filter/payapp-multi-filter.component';
import { ProjectsLocationMapComponent } from './components/maps/projects-location-map/projects-location-map.component';
import { MapWrapperComponent } from './components/maps/map-wrapper/map-wrapper.component';
import {
  SiteWiseReportsComponent,
} from './pages/projects-details-page/components/tab-screens/sites/site-wise-reports/site-wise-reports.component';
import {
  ReportMapDataExportComponent,
} from './pages/projects-details-page/components/tab-screens/sites/report-map-data-export/report-map-data-export.component';
import {
  SiteReportCardComponent,
} from './pages/projects-details-page/components/tab-screens/sites/site-report-card/site-report-card.component';
import {
  SiteReportsPanelComponent,
} from './pages/projects-details-page/components/tab-screens/sites/site-reports-panel/site-reports-panel.component';
import {
  ProjectSettingsComponent,
} from './pages/projects-details-page/components/tab-screens/settings/project-settings/project-settings.component';
import {
  ProjectBillingSettingsComponent,
} from './pages/projects-details-page/components/tab-screens/settings/project-billing-settings/project-billing-settings.component';
import {
  ProjectArchiveComponent,
} from './pages/projects-details-page/components/tab-screens/settings/project-archive/project-archive.component';
import {
  ArcgisPushComponent,
} from './pages/projects-details-page/components/tab-screens/settings/arcgis-push/arcgis-push.component';
import {
  AccountManagementComponent,
} from './pages/projects-details-page/components/tab-screens/settings/accounts/account-management/account-management.component';
import {
  CreateOrEditUserComponent,
} from './pages/projects-details-page/components/tab-screens/settings/accounts/create-or-edit-user/create-or-edit-user.component';
import {
  ContractorsListComponent,
} from './pages/projects-details-page/components/tab-screens/settings/contractors/contractors-list/contractors-list.component';
import {
  CreateOrEditContractorComponent,
} from './pages/projects-details-page/components/tab-screens/settings/contractors/create-or-edit-contractor/create-or-edit-contractor.component';
import {
  SettingsBidItemsListComponent,
} from './pages/projects-details-page/components/tab-screens/settings/bid-items/bid-items-list/bid-items-list.component';
import {
  CreateOrEditBidItemComponent,
} from './pages/projects-details-page/components/tab-screens/settings/bid-items/create-or-edit-bid-item/create-or-edit-bid-item.component';
import {
  BidItemSideNavWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/settings/bid-items/bid-item-side-nav-wrapper/bid-item-side-nav-wrapper.component';
import {
  UploadBidItemsComponent,
} from './pages/projects-details-page/components/tab-screens/settings/bid-items/upload-bid-items/upload-bid-items.component';
import {
  BidItemsFieldsComponent,
} from './pages/projects-details-page/components/tab-screens/settings/bid-items/bid-items-fields/bid-items-fields.component';
import {
  BidItemsMaterialsComponent,
} from './pages/projects-details-page/components/tab-screens/settings/bid-items/bid-items-materials/bid-items-materials.component';
import {
  BidItemsSiteQuantitiesComponent,
} from './pages/projects-details-page/components/tab-screens/settings/bid-items/bid-items-site-quantities/bid-items-site-quantities.component';
import { FieldsItemComponent } from './pages/projects-details-page/components/tab-screens/settings/bid-items/fields-item/fields-item.component';
import {
  BidItemsShapesComponent,
} from './pages/projects-details-page/components/tab-screens/settings/bid-items/bid-items-shapes/bid-items-shapes.component';
import {
  SitesListComponent,
} from './pages/projects-details-page/components/tab-screens/settings/sites/sites-list/sites-list.component';
import {
  CreateOrEditSiteComponent,
} from './pages/projects-details-page/components/tab-screens/settings/sites/create-or-edit-site/create-or-edit-site.component';
import {
  MapLayersListComponent,
} from './pages/projects-details-page/components/tab-screens/settings/map-layers/map-layers-list/map-layers-list.component';
import { MapLayerGroupDialogComponent } from './pages/projects-details-page/components/tab-screens/settings/map-layers/map-layer-group-dialog/map-layer-group-dialog.component';
import {
  CreateOrEditMapLayerComponent,
} from './pages/projects-details-page/components/tab-screens/settings/map-layers/create-or-edit-map-layer/create-or-edit-map-layer.component';
import {
  LaborSetupScreenComponent,
} from './pages/projects-details-page/components/tab-screens/settings/labour/labour-setup-screen/labour-setup-screen.component';
import {
  LaborSetupPopupComponent,
} from './pages/projects-details-page/components/tab-screens/settings/labour/labour-setup-popup/labour-setup-popup.component';
import {
  EquipmentSetupScreenComponent,
} from './pages/projects-details-page/components/tab-screens/settings/equipment/equipment-setup-screen/equipment-setup-screen.component';
import {
  EquipmentSetupPopupComponent,
} from './pages/projects-details-page/components/tab-screens/settings/equipment/equipment-setup-popup/equipment-setup-popup.component';
import {
  ExternalLabSetupScreenComponent,
} from './pages/projects-details-page/components/tab-screens/settings/external-lab/external-lab-setup-screen/external-lab-setup-screen.component';
import {
  CreateOrEditExternalLabComponent,
} from './pages/projects-details-page/components/tab-screens/settings/external-lab/create-or-edit-external-lab/create-or-edit-external-lab.component';
import {
  ActivityTypeSetupScreenComponent,
} from './pages/projects-details-page/components/tab-screens/settings/activity-type/activity-type-setup-screen/activity-type-setup-screen.component';
import {
  ActivityTypeSetupPopupComponent,
} from './pages/projects-details-page/components/tab-screens/settings/activity-type/activity-type-setup-popup/activity-type-setup-popup.component';
import {
  FormsListComponent,
} from './pages/projects-details-page/components/tab-screens/settings/forms/forms-list/forms-list.component';
import {
  FormPreviewComponent,
} from './pages/projects-details-page/components/tab-screens/settings/forms/form-preview/form-preview.component';
import {
  MaterialTestListComponent,
} from './pages/projects-details-page/components/tab-screens/settings/material-test/material-test-list/material-test-list.component';
import {
  MaterialTestCreateEditPopupComponent,
} from './pages/projects-details-page/components/tab-screens/settings/material-test/material-test-create-edit-popup/material-test-create-edit-popup.component';
import {
  DeliveryTrackingListComponent,
} from './pages/projects-details-page/components/tab-screens/settings/delivery-tracking/delivery-tracking-list/delivery-tracking-list.component';
import {
  CreateOrEditDeliveryTrackingComponent,
} from './pages/projects-details-page/components/tab-screens/settings/delivery-tracking/create-or-edit-delivery-tracking/create-or-edit-delivery-tracking.component';
import {
  DeliveryTrackingTabWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/settings/delivery-tracking/delivery-tracking-tab-wrapper/delivery-tracking-tab-wrapper.component';
import {
  DeliveryTrackingMaterialsDialogComponent,
} from './pages/projects-details-page/components/tab-screens/settings/delivery-tracking/delivery-tracking-materials-dialog/delivery-tracking-materials-dialog.component';
import {
  DeliveryTrackingBidItemsComponent,
} from './pages/projects-details-page/components/tab-screens/settings/delivery-tracking/delivery-tracking-bid-items/delivery-tracking-bid-items.component';
import {
  DeliveryTrackingMaterialsComponent,
} from './pages/projects-details-page/components/tab-screens/settings/delivery-tracking/delivery-tracking-materials/delivery-tracking-materials.component';
import {
  DeliveryTrackingMaterialsEditComponent,
} from './pages/projects-details-page/components/tab-screens/settings/delivery-tracking/delivery-tracking-materials-edit/delivery-tracking-materials-edit.component';
import { ProjectModule } from '../project/project.module';
import { IssuesTabComponent } from './pages/projects-details-page/components/tab-screens/issues/issues-tab.component';
import { MultiSectionFilterComponent } from './pages/projects-details-page/components/filters/multi-section-filter/multi-section-filter.component';
import { SortDropdownComponent } from './pages/projects-details-page/components/filters/sort-dropdown/sort-dropdown.component';
import { SubContractorModule } from '../sub-contractor/sub-contractor.module';
import { SitesLocationMapComponent } from './components/maps/sites-location-map/sites-location-map.component';
import { MapControlsComponent } from './components/maps/sites-location-map/map-controls/map-controls.component';
import { NoLocationBadgeComponent } from './components/maps/no-location-badge/no-location-badge.component';
import { PayappComponent } from './pages/projects-details-page/components/tab-screens/pay-app/pay-app.component';
import {
  PayAppSummaryComponent,
} from './pages/projects-details-page/components/tab-screens/pay-app/pay-app-summary/pay-app-summary.component';
import {
  CreatePayappDialogComponent,
} from './pages/projects-details-page/components/dialogs/create-payapp-dialog/create-payapp-dialog.component';
import {
  PayappCommentsDialogComponent,
} from './pages/projects-details-page/components/dialogs/payapp-comments-dialog/payapp-comments-dialog.component';
import {
  MohWarningAckDialogComponent,
} from './pages/projects-details-page/components/dialogs/moh-warning-ack-dialog/moh-warning-ack-dialog.component';
import { AddReasonComponent } from './pages/projects-details-page/components/dialogs/add-reason/add-reason.component';
import {
  ConsolidatedReportWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-report-wrapper/consolidated-report-wrapper.component';
import {
  ProjectReportsListComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/project-reports-list/project-reports-list.component';
import {
  ProjectReportsCardComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/project-reports-card/project-reports-card.component';
import { CdkConnectedOverlay, CdkOverlayOrigin } from '@angular/cdk/overlay';
import { SiteDetailsScreenComponent } from './pages/site-details-page/screen/site-details-screen.component';
import {
  DailyReportWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-wrapper/daily-report-wrapper.component';
import { DailyReportComponent } from './pages/site-details-page/tab-screens/daily-report/daily-report/daily-report.component';
import {
  DailyReportExpandableBlockComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-expandable-block/daily-report-expandable-block.component';
import {
  DailyReportsListComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-reports-list/daily-reports-list.component';
import {
  StationWiseBidItemSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/bid-item-summary/station-wise-bid-item-summary/station-wise-bid-item-summary.component';
import {
  MultilineBidItemSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/bid-item-summary/multiline-bid-item-summary/multiline-bid-item-summary.component';
import {
  BidItemDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/bid-item-details/bid-item-details-wrapper/bid-item-details-wrapper.component';
import {
  StationWiseBidItemDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/bid-item-details/station-wise-bid-item-details/station-wise-bid-item-details.component';
import {
  MultilineBidItemDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/bid-item-details/multiline-bid-item-details/multiline-bid-item-details.component';
import { ActionsSectionComponent } from './pages/site-details-page/components/actions-section/actions-section.component';
import {
  BidItemsListComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders/bid-items-list/bid-items-list.component';
import {
  UploadChangesComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders/upload-changes/upload-changes.component';
import {
  BidItemsSideNavScreenComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders/bidItemsSideNav/bid-items-side-nav-screen/bid-items-side-nav-screen.component';
import {
  BidItemsSitesDetailsComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders/bidItemsSideNav/components/bid-items-sites-details/bid-items-sites-details.component';
import { SuccessComponent } from './pages/projects-details-page/components/tab-screens/change-orders/success-component/success.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  BidItemDetailsAddBidItemComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/bid-item-details/bid-item-details-add-bid-item/bid-item-details-add-bid-item.component';
import {
  AddItemPostingComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/add-item-posting/add-item-posting.component';
import {
  ItemPostingsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/item-postings-wrapper/item-postings-wrapper.component';
import {
  ItemPostingsDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/item-postings-details/item-postings-details.component';
import {
  ItemPostingLineItemComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/item-posting-line-item/item-posting-line-item.component';
import {
  ItemPostingsStationPopupComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/item-postings-station-popup/item-postings-station-popup.component';
import {
  ItemPostingsMaterialSetDialogComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/item-postings-material-set-dialog/item-postings-material-set-dialog.component';
import {
  ItemPostingsAcceptanceRecordDialogComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/item-postings-acceptance-record-dialog/item-postings-acceptance-record-dialog.component';
import {
  ItemPostingsCustomGroupDialogComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/item-postings/item-postings-custom-group-dialog/item-postings-custom-group-dialog.component';
import {
  ItemPostingSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/item-posting-summary/item-posting-summary.component';
import {
  ActivitySummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/activity-summary/activity-summary.component';
import {
  ActivityItemDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/activitiy-details/activity-item-details/activity-item-details.component';
import {
  NotesSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/notes-summary/notes-summary.component';
import {
  NotesDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/notes-details/notes-details.component';
import {
  ConsolidatedReportComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-report/consolidated-report.component';
import {
  ConsolidatedReportExpandableBlockComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-report-expandable-block/consolidated-report-expandable-block.component';
import {
  BidItemsExpandableRowTableComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-reports-components/summary-components/bid-items-expandable-row-table/bid-items-expandable-row-table.component';
import {
  ConsolidatedReportBidItemDetailsComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-reports-components/detail-components/consolidated-report-bid-item-details/consolidated-report-bid-item-details.component';

import {
  MaterialDeliveryAndUsageSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/material-delivery-and-usage-summary/material-delivery-and-usage-summary.component';
import {
  WeatherSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/weather-summary/weather-summary.component';
import {
  IssueSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/issue-summary/issue-summary.component';
import {
  AddDeliveryDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/delivery-details/add-delivery-details/add-delivery-details.component';
import {
  AddUsageDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/usage-details/add-usage-details/add-usage-details.component';
import {
  DeliveryDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/delivery-details/delivery-details-wrapper/delivery-details-wrapper.component';
import {
  DeliveryDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/delivery-details/delivery-details/delivery-details.component';
import {
  DeliveryDetailsFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/delivery-details/delivery-details-form/delivery-details-form.component';
import {
  UsageDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/usage-details/usage-details/usage-details.component';
import {
  UsageDetailsFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/usage-details/usage-details-form/usage-details-form.component';
import {
  UsageDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/usage-details/usage-details-wrapper/usage-details-wrapper.component';
import {
  LaborSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/labor-summary/labor-summary.component';
import {
  EquipmentSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/equipment-summary/equipment-summary.component';
import {
  CleContractorSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/cle-contractor-summary/cle-contractor-summary.component';
import {
  CleLaborSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/cle-labor-summary/cle-labor-summary.component';
import {
  CleEquipmentSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/cle-equipment-summary/cle-equipment-summary.component';
import {
  LaborDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/labor-details/labor-details-wrapper/labor-details-wrapper.component';
import {
  EquipmentDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/equipment-details/equipment-details-wrapper/equipment-details-wrapper.component';
import {
  LaborEquipmentLineItemComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/labor-equipment/labor-equipment-line-item/labor-equipment-line-item.component';
import {
  MultiLaborEquipmentDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/labor-equipment/multi-labor-equipment-details/multi-labor-equipment-details.component';
import {
  CleContractorDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-contractor-details-wrapper/cle-contractor-details-wrapper.component';
import {
  CleContractorFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-contractor-form/cle-contractor-form.component';
import {
  AddContractorDialogComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/add-contractor-dialog/add-contractor-dialog.component';
import {
  CleLaborDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-labor-details-wrapper/cle-labor-details-wrapper.component';
import {
  CleAddLaborFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-add-labor-form/cle-add-labor-form.component';
import {
  CleEditLaborFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-edit-labor-form/cle-edit-labor-form.component';
import {
  CleEquipmentDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-equipment-details-wrapper/cle-equipment-details-wrapper.component';
import {
  CleAddEquipmentFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-add-equipment-form/cle-add-equipment-form.component';
import {
  CleEditEquipmentFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/contractor-details/cle-edit-equipment-form/cle-edit-equipment-form.component';
import {
  WeatherDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/weather-details/weather-details-wrapper/weather-details-wrapper.component';
import {
  WeatherDetailsFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/weather-details/weather-details-form/weather-details-form.component';
import {
  IssueDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/issue-details/issue-details-wrapper/issue-details-wrapper.component';
import {
  IssueDetailsFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/issue-details/issue-details-form/issue-details-form.component';
import { SiteDetailsMapComponent } from './components/maps/site-details-map/site-details-map.component';
import {
  InternalTestDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/internal-test-details/internal-test-details-wrapper/internal-test-details-wrapper.component';
import {
  InternalTestDetailsFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/internal-test-details/internal-test-details-form/internal-test-details-form.component';
import {
  InternalTestDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/internal-test-details/internal-test-details/internal-test-details.component';
import {
  InternalTestDetailsWithoutStationComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/internal-test-details/internal-test-details-without-station/internal-test-details-without-station.component';
import {
  InternalTestDetailsWithStationComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/internal-test-details/internal-test-details-with-station/internal-test-details-with-station.component';
import {
  CreateInternalTestComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/internal-test-details/create-internal-test/create-internal-test.component';
import {
  MaterialTestSummaryExternalComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/material-test-summary/material-test-summary-external/material-test-summary-external.component';
import {
  MaterialTestSummaryInternalComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/material-test-summary/material-test-summary-internal/material-test-summary-internal.component';
import {
  ConsolidatedWeatherSummaryCardComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-reports-components/summary-components/consolidated-weather-summary-card/consolidated-weather-summary-card.component';
import {
  ConsolidatedReportWeatherDetailsComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-reports-components/detail-components/consolidated-report-weather-details/consolidated-report-weather-details.component';
import {
  ConsolidatedReportIssuesSummaryCardComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-reports-components/summary-components/consolidated-report-issues-summary-card/consolidated-report-issues-summary-card.component';
import {
  ConsolidatedReportIssueDetailsComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-reports-components/detail-components/consolidated-report-issue-details/consolidated-report-issue-details.component';
import {
  ConsolidatedReportActivitySummaryCardComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-reports-components/summary-components/consolidated-report-activity-summary-card/consolidated-report-activity-summary-card.component';
import {
  ConsolidatedReportActivityDetailsComponent,
} from './pages/projects-details-page/components/tab-screens/consolidated-reports/consolidated-reports-components/detail-components/consolidated-report-activity-details/consolidated-report-activity-details.component';
import {
  ActivityCodesDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/activity-codes-details/activity-codes-details-wrapper/activity-codes-details-wrapper.component';
import {
  ActivityCodesDetailsFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/activity-codes-details/activity-codes-details-form/activity-codes-details-form.component';
import {
  ActivityCodesSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/activity-codes-summary/activity-codes-summary.component';
import {
  QuestionsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/questions/questions.component';
import { MaterialModule } from '../../material/material.module';
import {
  GeneralQuestionFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/general-question-form/general-question-form.component';
import {
  QuestionActionSectionComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/question-action-section/question-action-section.component';
import {
  FormsSummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/forms-summary/forms-summary.component';
import {
  SignatureComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/signature/signature.component';
import {
  ControlFormDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/control-form-details-wrapper/control-form-details-wrapper.component';
import {
  ControlFormsDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/control-forms-details/control-forms-details.component';
import {
  GenericFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/generic-form/generic-form.component';
import {
  GenericFormWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/generic-form/generic-form-wrapper/generic-form-wrapper.component';
import {
  FrequencyQuestionFormComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/frequency-question-form/frequency-question-form.component';
import {
  StationRangeComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/control-forms-details/station-range/station-range.component';
import {
  ActivityCodesStationRangeComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/activity-codes-details/activity-codes-station-range/activity-codes-station-range.component';

import {
  SurveyDataMapComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/bid-item-details/survey-data-map/survey-data-map.component';
import {
  LocationStationCardComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/location-station-card/location-station-card.component';
import {
  ActivityCodesListComponent,
} from './pages/projects-details-page/components/tab-screens/activity-codes/activity-codes-list/activity-codes-list.component';
import {
  ActivityIdsListSideNavScreenComponent,
} from './pages/projects-details-page/components/tab-screens/activity-codes/activityIdsListSideNav/activity-ids-list-side-nav-screen/activity-ids-list-side-nav-screen.component';
import {
  ActivityIdDetailsComponent,
} from './pages/projects-details-page/components/tab-screens/activity-codes/activityIdsListSideNav/components/activity-id-details/activity-id-details.component';
import {
  UploadActivityIdsFileComponent,
} from './pages/projects-details-page/components/tab-screens/activity-codes/upload-activity-ids-file/upload-activity-ids-file.component';
import { ActionSectionComponent } from './pages/projects-details-page/components/action-section/action-section.component';
import { ChangesWrapperComponent } from './pages/site-details-page/tab-screens/daily-report/changes-wrapper/changes-wrapper.component';
import { MatPaginatorModule as MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import {
  TestingFormDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/testing-form-details/testing-form-details-wrapper/testing-form-details-wrapper.component';
import {
  TestingFromComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/testing-form-details/testing-from/testing-from.component';
import {
  StationComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/testing-form-details/station/station.component';
import {
  ChangeInWorkRequestListComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/change-in-work-request-list/change-in-work-request-list.component';
import {
  ChangeInWorkRequestFiltersComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/change-in-work-request-filters/change-in-work-request-filters.component';
import {
  ChangeInWorkRequestWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/change-in-work-request-wrapper/change-in-work-request-wrapper.component';
import {
  ChangeInWorkRequestSideNavWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/change-in-work-request-side-nav-wrapper/change-in-work-request-side-nav-wrapper.component';
import {
  CreateEditChangeInWorkRequestFormComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/create-edit-change-in-work-request-form/create-edit-change-in-work-request-form.component';
import {
  ChangeInWorkRequestWorkflowComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/change-in-work-request-workflow/change-in-work-request-workflow.component';
import {
  AddCloseCommentComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/issue-details/add-close-comment/add-close-comment.component';
import {
  ChangeInWorkRequestReportComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/change-in-work-request-report/change-in-work-request-report.component';
import {
  AddReasonOrSignatureComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/add-reason-or-signature/add-reason-or-signature.component';
import { TabGroupComponent } from './pages/projects-details-page/components/tab-group/tab-group.component';
import { StatusFilterComponent } from './pages/projects-details-page/components/tab-screens/status-filter/status-filter.component';
import { TabbedFilterComponent } from './pages/projects-details-page/components/tab-screens/tabbed-filter/tabbed-filter.component';
import {
  ChangeInWorkRequestLineItemComponent,
} from './pages/projects-details-page/components/tab-screens/change-in-work-request/change-in-work-request-line-item/change-in-work-request-line-item.component';
import { MapLayerContainerComponent } from './components/maps/map-layer-container/map-layer-container.component';
import { DailyReportMapContainerComponent } from './components/maps/daily-report-map-container/daily-report-map-container.component';
import { MapSidenavComponent } from './components/maps/map-sidenav/map-sidenav.component';
import { ClaimDetailSidenavComponent } from './components/maps/claim-detail-sidenav/claim-detail-sidenav.component';
import { IssueDetailSidenavComponent } from './components/maps/issue-detail-sidenav/issue-detail-sidenav.component';
import { MapSidenavBidItemWrapperComponent } from './components/maps/map-sidenav-bid-item-wrapper/map-sidenav-bid-item-wrapper.component';
import { MapSearchBarComponent } from './components/maps/map-search-bar/map-search-bar.component';
import { MapFiltersOverlayComponent } from './components/maps/map-filters-overlay/map-filters-overlay.component';
import {
  ChangeOrdersRequestWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/change-orders-request-wrapper/change-orders-request-wrapper.component';
import {
  ChangeOrdersRequestFiltersComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/change-orders-request-filters/change-orders-request-filters.component';
import {
  ChangeOrdersRequestListComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/change-orders-request-list/change-orders-request-list.component';
import {
  ChangeOrdersRequestSideNavWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/change-orders-request-side-nav-wrapper/change-orders-request-side-nav-wrapper.component';
import {
  ChangeOrdersRequestFormComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/change-orders-request-form/change-orders-request-form.component';
import {
  ChangeOrdersRequestWorkflowComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/change-orders-request-workflow/change-orders-request-workflow.component';
import {
  ChangeOrdersRequestReportComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/change-orders-request-report/change-orders-request-report.component';
import {
  ChangeOrdersRequestLineItemComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/change-orders-request-line-item/change-orders-request-line-item.component';
import {
  CreateChangeOrderDialogComponent,
} from './pages/projects-details-page/components/tab-screens/change-orders-request/create-change-order-dialog/create-change-order-dialog.component';
import {
  SubmittalsWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/submittals/submittals-wrapper/submittals-wrapper.component';
import {
  SubmittalsTabGroupComponent,
} from './pages/projects-details-page/components/tab-screens/submittals/submittals-tab-group/submittals-tab-group.component';
import {
  SubmittalsRegistryComponent,
} from './pages/projects-details-page/components/tab-screens/submittals/submittals-registry/submittals-registry.component';
import {
  SubmittalsListComponent,
} from './pages/projects-details-page/components/tab-screens/submittals/submittals-list/submittals-list.component';
import {
  CreateOrEditSubmittalsRegistryComponent,
} from './pages/projects-details-page/components/tab-screens/submittals/create-or-edit-submittals-registry/create-or-edit-submittals-registry.component';
import {
  CreateOrEditSubmittalsItemComponent,
} from './pages/projects-details-page/components/tab-screens/submittals/create-or-edit-submittals-item/create-or-edit-submittals-item.component';
import {
  SubmittalsWorkflowComponent,
} from './pages/projects-details-page/components/tab-screens/submittals/submittals-workflow/submittals-workflow.component';
import { RfisWrapperComponent } from './pages/projects-details-page/components/tab-screens/rfis/rfis-wrapper/rfis-wrapper.component';
import { RfisListComponent } from './pages/projects-details-page/components/tab-screens/rfis/rfis-list/rfis-list.component';
import {
  CreateOrEditRfisItemComponent,
} from './pages/projects-details-page/components/tab-screens/rfis/create-or-edit-rfis-item/create-or-edit-rfis-item.component';
import { RfisWorkflowComponent } from './pages/projects-details-page/components/tab-screens/rfis/rfis-workflow/rfis-workflow.component';
import {
  SampleRecordsWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/sample-records/sample-records-wrapper/sample-records-wrapper.component';
import {
  SampleRecordsListComponent,
} from './pages/projects-details-page/components/tab-screens/sample-records/sample-records-list/sample-records-list.component';
import {
  CreateOrEditSampleRecordComponent,
} from './pages/projects-details-page/components/tab-screens/sample-records/create-or-edit-sample-record/create-or-edit-sample-record.component';
import {
  EmbeddedSampleRecordsComponent,
} from './pages/projects-details-page/components/tab-screens/sample-records/embedded/embedded-sample-records.component';
import {
  SampleLocationPopupComponent,
} from './pages/projects-details-page/components/tab-screens/sample-records/sample-location-popup/sample-location-popup.component';
import {
  SampleTestEntryComponent,
} from './pages/projects-details-page/components/tab-screens/sample-records/sample-test-entry/sample-test-entry.component';
import { RfiSummaryComponent } from './pages/projects-page/components/rfi-summary/rfi-summary.component';
import { SubmittalsSummaryComponent } from './pages/projects-page/components/submittals-summary/submittals-summary.component';
import {
  RfisSubmittalsCombinedComponent,
} from './pages/projects-page/components/rfis-submittals-combined/rfis-submittals-combined.component';
import {
  ChangeOrderTabWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/change-order-tab-wrapper/change-order-tab-wrapper.component';
import {
  WorkdayDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/workday-details/workday-details-wrapper/workday-details-wrapper.component';
import {
  WorkdaySummaryComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/summary-components/workday-summary/workday-summary.component';
import {
  CreateExternalTestComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/create-external-test/create-external-test.component';
import {
  ExternalTestDetailsWrapperComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-details-wrapper/external-test-details-wrapper.component';
import {
  ExternalTestDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-details/external-test-details.component';
import {
  CancelTestDialogComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/cancel-test-dialog/cancel-test-dialog.component';
import {
  ExternalTestDetailsExpandableBlockComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-details-expandable-block/external-test-details-expandable-block.component';
import {
  ExternalTestRequestDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-request-details/external-test-request-details.component';
import {
  ExternalTestScheduleDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-schedule-details/external-test-schedule-details.component';
import {
  ExternalTestRecordLabTestDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-record-lab-test-details/external-test-record-lab-test-details.component';
import {
  ExternalTestReportDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-report-details/external-test-report-details.component';
import {
  ExternalTestResultDetailsComponent,
} from './pages/site-details-page/tab-screens/daily-report/daily-report-components/detail-components/external-test-details/external-test-result-details/external-test-result-details.component';
import { CopyDailyReportComponent } from './pages/site-details-page/components/copy-daily-report/copy-daily-report.component';
import {
  DocumentsWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/documents/documents-wrapper/documents-wrapper.component';
import {
  DrawingsWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawings-wrapper/drawings-wrapper.component';
import {
  DrawingsRegisterComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawings-register/drawings-register.component';
import {
  DrawingUploadDialogComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-upload-dialog/drawing-upload-dialog.component';
import { DrawingPublishDialogComponent } from './pages/projects-details-page/components/tab-screens/drawings/drawing-publish-dialog/drawing-publish-dialog.component';
import { DrawingsAsBuiltComponent } from './pages/projects-details-page/components/tab-screens/drawings/drawings-as-built/drawings-as-built.component';
import { DrawingExportDialogComponent } from './pages/projects-details-page/components/tab-screens/drawings/drawing-export-dialog/drawing-export-dialog.component';
import {
  DrawingSetReviewComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-set-review/drawing-set-review.component';
import {
  DrawingSetPagePanelComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-set-page-panel/drawing-set-page-panel.component';
import {
  DrawingSetPageViewerComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-set-page-viewer/drawing-set-page-viewer.component';
import { DRAWING_ADD_TO_PANELS } from './pages/projects-details-page/components/tab-screens/drawings/drawing-add-to';
import { DRAWING_MAP_PANELS } from './pages/projects-details-page/components/tab-screens/drawings/drawing-map-panels';
import {
  DrawingPlaceDialogComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-place-dialog/drawing-place-dialog.component';
import {
  DrawingLinkedPanelComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-linked-panel/drawing-linked-panel.component';
import {
  DrawingSheetViewerComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-sheet-viewer/drawing-sheet-viewer.component';
import {
  DrawingSheetEditPanelComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-sheet-edit-panel/drawing-sheet-edit-panel.component';
import {
  SheetZoomControlsComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/sheet-zoom-controls/sheet-zoom-controls.component';
import {
  DrawingsPageHeaderComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawings-page-header/drawings-page-header.component';
import {
  DrawingCompareOverlayComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-compare-overlay/drawing-compare-overlay.component';
import {
  DrawingCompareComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-compare/drawing-compare.component';
import {
  DrawingCarryForwardComponent,
} from './pages/projects-details-page/components/tab-screens/drawings/drawing-carry-forward/drawing-carry-forward.component';
import {
  DocumentsTableComponent,
} from './pages/projects-details-page/components/tab-screens/documents/documents-table/documents-table.component';
import {
  CreateNewFolderComponent,
} from './pages/projects-details-page/components/tab-screens/documents/create-new-folder/create-new-folder.component';
import { EditNameComponent } from './pages/projects-details-page/components/tab-screens/documents/edit-name/edit-name.component';
import {
  WarrantyWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-wrapper.component';
import {
  WarrantySettingsComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-settings.component';
import {
  WarrantyClaimsListComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-claims-list.component';
import {
  WarrantyClaimDetailComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-claim-detail.component';
import {
  WarrantyClaimFormComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-claim-form.component';
import {
  WarrantySettingsFormComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-settings-form.component';
import {
  WarrantyTasksComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-tasks.component';
import {
  WarrantyTasksListComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-tasks-list.component';
import {
  WarrantyPackagesListComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-packages-list.component';
import {
  WarrantyPackageFormComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-package-form.component';
import {
  WarrantyPackageDetailComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-package-detail.component';
import {
  WarrantyStateDiagramComponent,
} from './pages/projects-details-page/components/tab-screens/warranty/warranty-state-diagram.component';
import {
  PunchlistWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/punchlist/punchlist-wrapper.component';
import {
  PunchlistSettingsComponent,
} from './pages/projects-details-page/components/tab-screens/punchlist/punchlist-settings.component';
import {
  PunchlistSettingsFormComponent,
} from './pages/projects-details-page/components/tab-screens/punchlist/punchlist-settings-form.component';
import {
  PunchlistItemsListComponent,
} from './pages/projects-details-page/components/tab-screens/punchlist/punchlist-items-list.component';
import {
  PunchlistItemFormComponent,
} from './pages/projects-details-page/components/tab-screens/punchlist/punchlist-item-form.component';
import {
  PunchlistItemDetailComponent,
} from './pages/projects-details-page/components/tab-screens/punchlist/punchlist-item-detail.component';
import {
  MappedReportListPageComponent,
} from './pages/projects-details-page/components/tab-screens/mapped-reports/mapped-report-list-page.component';
import {
  CreateDailyDiaryComponent,
} from './pages/site-details-page/tab-screens/daily-diary/create-daily-diary/create-daily-diary.component';
import {
  ProjectDiariesWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/project-diaries/project-diaries-wrapper.component';
import {
  DailyDiaryDayComponent,
} from './pages/site-details-page/tab-screens/daily-diary/daily-diary-day/daily-diary-day.component';
import {
  DailyDiaryDetailComponent,
} from './pages/site-details-page/tab-screens/daily-diary/daily-diary-detail/daily-diary-detail.component';
import {
  DailyDiaryFormComponent,
} from './pages/site-details-page/tab-screens/daily-diary/daily-diary-form/daily-diary-form.component';
import {
  MgvwRecordsWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/mgvw/mgvw-records-wrapper/mgvw-records-wrapper.component';
import {
  MgvwRecordsListComponent,
} from './pages/projects-details-page/components/tab-screens/mgvw/mgvw-records-list/mgvw-records-list.component';
import {
  CreateOrEditMgvwRecordComponent,
} from './pages/projects-details-page/components/tab-screens/mgvw/create-or-edit-mgvw-record/create-or-edit-mgvw-record.component';
import {
  RiskRegisterWrapperComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-register-wrapper/risk-register-wrapper.component';
import {
  RiskRegisterListComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-register-list/risk-register-list.component';
import {
  RiskHeatMapComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-heat-map/risk-heat-map.component';
import {
  RiskDetailPanelComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-detail-panel/risk-detail-panel.component';
import {
  RiskFormComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-form/risk-form.component';
import {
  RiskConfigDialogComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-config-dialog/risk-config-dialog.component';
import {
  RiskImportDialogComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-import-dialog/risk-import-dialog.component';
import {
  RiskExportDialogComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-export-dialog/risk-export-dialog.component';
import {
  RiskUpdatesTimelineComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-updates-timeline/risk-updates-timeline.component';
import {
  RiskUpdateFormComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-update-form/risk-update-form.component';
import {
  RiskScoreChipComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-score-chip/risk-score-chip.component';
import {
  RiskCommentDialogComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-comment-dialog/risk-comment-dialog.component';
import {
  RiskConvertDialogComponent,
} from './pages/projects-details-page/components/tab-screens/risk-register/risk-convert-dialog/risk-convert-dialog.component';
import {
  DailyDiaryFiltersComponent,
} from './pages/site-details-page/tab-screens/daily-diary/daily-diary-filters/daily-diary-filters.component';
import {
  MappedReportViewerPageComponent,
} from './pages/mapped-report-viewer-page/screen/mapped-report-viewer-page.component';
import {
  MappedReportPdfPaneComponent,
} from './pages/mapped-report-viewer-page/pdf-pane/mapped-report-pdf-pane.component';
import {
  MappedReportMapPaneComponent,
} from './pages/mapped-report-viewer-page/map-pane/mapped-report-map-pane.component';

// Custom DateAdapter for calendar styling per Figma design
class CustomCalendarDateAdapter extends MomentDateAdapter {
  // Override day of week names to return 3-letter abbreviations (SUN, MON, TUE, etc.)
  override getDayOfWeekNames(style: 'long' | 'short' | 'narrow'): string[] {
    // Always return 3-letter abbreviations regardless of style requested
    return ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
  }

  override format(date: moment.Moment, displayFormat: string): string {
    const result = super.format(date, displayFormat);
    // Apply title case to month names (November instead of NOVEMBER)
    if (displayFormat && (
      displayFormat.includes('MMMM') ||
      displayFormat.includes('MMM') ||
      displayFormat === 'monthYearLabel'
    )) {
      return this.toTitleCase(result);
    }
    return result;
  }

  // Override getMonthNames to return title case
  override getMonthNames(style: 'long' | 'short' | 'narrow'): string[] {
    const months = super.getMonthNames(style);
    return months.map(month => this.toTitleCase(month));
  }

  private toTitleCase(str: string): string {
    if (!str) {
      return str;
    }
    return str.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
  }
}

// Custom date format for calendar - uses title case month names (November instead of NOVEMBER)
const MAP_CALENDAR_DATE_FORMATS = {
  parse: {
    dateInput: 'MM/DD/YYYY',
  },
  display: {
    dateInput: 'MM/DD/YYYY',
    monthYearLabel: 'MMMM YYYY',  // "November 2025" format (title case from moment.js)
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  declarations: [
    ProjectsWrapperComponent,
    ProjectsPageComponent,
    ProjectCardComponent,
    EditProjectDetailsComponent,
    IssuesSummaryComponent,
    ClaimsSummaryComponent,
    OffsiteTestsSummaryComponent,
    StatusSummaryComponent,
    ContractProgressCardComponent,
    ProjectDetailsScreenComponent,
    CreateDailyReportComponent,
    StatusSiteFilterComponent,
    DateFilterComponent,
    PayappDateFilterComponent,
    PayappMultiFilterComponent,
    ProjectsLocationMapComponent,
    MapWrapperComponent,
    SiteWiseReportsComponent,
    SiteReportCardComponent,
    SiteReportsPanelComponent,
    ProjectSettingsComponent,
    ProjectBillingSettingsComponent,
    ProjectArchiveComponent,
    ArcgisPushComponent,
    AccountManagementComponent,
    CreateOrEditUserComponent,
    ContractorsListComponent,
    CreateOrEditContractorComponent,
    SettingsBidItemsListComponent,
    CreateOrEditBidItemComponent,
    BidItemSideNavWrapperComponent,
    UploadBidItemsComponent,
    BidItemsFieldsComponent,
    BidItemsMaterialsComponent,
    BidItemsSiteQuantitiesComponent,
    BidItemsShapesComponent,
    FieldsItemComponent,
    SitesListComponent,
    CreateOrEditSiteComponent,
    MapLayersListComponent,
    MapLayerGroupDialogComponent,
    CreateOrEditMapLayerComponent,
    LaborSetupScreenComponent,
    LaborSetupPopupComponent,
    EquipmentSetupScreenComponent,
    EquipmentSetupPopupComponent,
    ExternalLabSetupScreenComponent,
    CreateOrEditExternalLabComponent,
    ActivityTypeSetupScreenComponent,
    ActivityTypeSetupPopupComponent,
    FormsListComponent,
    FormPreviewComponent,
    MaterialTestListComponent,
    MaterialTestCreateEditPopupComponent,
    DeliveryTrackingListComponent,
    CreateOrEditDeliveryTrackingComponent,
    DeliveryTrackingTabWrapperComponent,
    DeliveryTrackingMaterialsDialogComponent,
    DeliveryTrackingMaterialsComponent,
    DeliveryTrackingMaterialsEditComponent,
    DeliveryTrackingBidItemsComponent,
    SitesLocationMapComponent,
    MapLayerContainerComponent,
    DailyReportMapContainerComponent,
    MapSidenavComponent,
    ClaimDetailSidenavComponent,
    IssueDetailSidenavComponent,
    MapSidenavBidItemWrapperComponent,
    MapSearchBarComponent,
    ConsolidatedReportWrapperComponent,
    PayappComponent,
    PayAppSummaryComponent,
    ProjectReportsListComponent,
    ProjectReportsCardComponent,
    SiteDetailsScreenComponent,
    DailyReportWrapperComponent,
    DailyReportComponent,
    DailyReportExpandableBlockComponent,
    DailyReportsListComponent,
    StationWiseBidItemSummaryComponent,
    MultilineBidItemSummaryComponent,
    BidItemDetailsWrapperComponent,
    StationWiseBidItemDetailsComponent,
    MultilineBidItemDetailsComponent,
    ActionsSectionComponent,
    BidItemsListComponent,
    UploadChangesComponent,
    BidItemsSideNavScreenComponent,
    BidItemsSitesDetailsComponent,
    AddItemPostingComponent,
    ItemPostingsWrapperComponent,
    ItemPostingsDetailsComponent,
    ItemPostingLineItemComponent,
    ItemPostingsStationPopupComponent,
    ItemPostingsMaterialSetDialogComponent,
    ItemPostingsAcceptanceRecordDialogComponent,
    ItemPostingsCustomGroupDialogComponent,
    ItemPostingSummaryComponent,
    SuccessComponent,
    CreatePayappDialogComponent,
    PayappCommentsDialogComponent,
    MohWarningAckDialogComponent,
    BidItemDetailsAddBidItemComponent,
    ActivitySummaryComponent,
    ActivityItemDetailsComponent,
    NotesSummaryComponent,
    NotesDetailsComponent,
    MaterialDeliveryAndUsageSummaryComponent,
    WeatherSummaryComponent,
    IssueSummaryComponent,
    AddDeliveryDetailsComponent,
    AddUsageDetailsComponent,
    DeliveryDetailsWrapperComponent,
    DeliveryDetailsComponent,
    DeliveryDetailsFormComponent,
    UsageDetailsComponent,
    UsageDetailsFormComponent,
    UsageDetailsWrapperComponent,
    LaborSummaryComponent,
    EquipmentSummaryComponent,
    CleContractorSummaryComponent,
    CleLaborSummaryComponent,
    CleEquipmentSummaryComponent,
    LaborDetailsWrapperComponent,
    EquipmentDetailsWrapperComponent,
    LaborEquipmentLineItemComponent,
    MultiLaborEquipmentDetailsComponent,
    CleContractorDetailsWrapperComponent,
    CleContractorFormComponent,
    AddContractorDialogComponent,
    CleLaborDetailsWrapperComponent,
    CleAddLaborFormComponent,
    CleEditLaborFormComponent,
    CleEquipmentDetailsWrapperComponent,
    CleAddEquipmentFormComponent,
    CleEditEquipmentFormComponent,
    WeatherDetailsWrapperComponent,
    WeatherDetailsFormComponent,
    IssueDetailsWrapperComponent,
    IssueDetailsFormComponent,
    MaterialTestSummaryExternalComponent,
    MaterialTestSummaryInternalComponent,
    AddReasonComponent,
    SiteDetailsMapComponent,
    ConsolidatedReportComponent,
    ConsolidatedReportExpandableBlockComponent,
    BidItemsExpandableRowTableComponent,
    ConsolidatedReportBidItemDetailsComponent,
    ConsolidatedWeatherSummaryCardComponent,
    ConsolidatedReportWeatherDetailsComponent,
    ConsolidatedReportIssuesSummaryCardComponent,
    ConsolidatedReportIssueDetailsComponent,
    ConsolidatedReportActivitySummaryCardComponent,
    ConsolidatedReportActivityDetailsComponent,
    InternalTestDetailsWrapperComponent,
    InternalTestDetailsFormComponent,
    InternalTestDetailsComponent,
    InternalTestDetailsWithoutStationComponent,
    InternalTestDetailsWithStationComponent,
    CreateInternalTestComponent,
    SurveyDataMapComponent,
    LocationStationCardComponent,
    ActivityCodesDetailsWrapperComponent,
    ActivityCodesDetailsFormComponent,
    ActivityCodesSummaryComponent,
    QuestionsComponent,
    GeneralQuestionFormComponent,
    QuestionActionSectionComponent,
    FormsSummaryComponent,
    SignatureComponent,
    ControlFormDetailsWrapperComponent,
    ControlFormsDetailsComponent,
    GenericFormComponent,
    GenericFormWrapperComponent,
    FrequencyQuestionFormComponent,
    StationRangeComponent,
    ActivityCodesStationRangeComponent,
    ActivityCodesListComponent,
    ActivityIdsListSideNavScreenComponent,
    ActivityIdDetailsComponent,
    UploadActivityIdsFileComponent,
    ActionSectionComponent,
    ChangesWrapperComponent,
    TestingFormDetailsWrapperComponent,
    TestingFromComponent,
    StationComponent,
    ChangeInWorkRequestListComponent,
    ChangeInWorkRequestFiltersComponent,
    ChangeInWorkRequestWrapperComponent,
    ChangeInWorkRequestSideNavWrapperComponent,
    CreateEditChangeInWorkRequestFormComponent,
    ChangeInWorkRequestWorkflowComponent,
    AddCloseCommentComponent,
    ChangeInWorkRequestReportComponent,
    AddReasonOrSignatureComponent,
    TabGroupComponent,
    StatusFilterComponent,
    TabbedFilterComponent,
    ChangeInWorkRequestLineItemComponent,
    ChangeOrdersRequestWrapperComponent,
    ChangeOrdersRequestFiltersComponent,
    ChangeOrdersRequestListComponent,
    ChangeOrdersRequestSideNavWrapperComponent,
    ChangeOrdersRequestFormComponent,
    ChangeOrdersRequestWorkflowComponent,
    ChangeOrdersRequestReportComponent,
    ChangeOrdersRequestLineItemComponent,
    CreateChangeOrderDialogComponent,
    MapFiltersOverlayComponent,
    SubmittalsWrapperComponent,
    SubmittalsTabGroupComponent,
    SubmittalsRegistryComponent,
    SubmittalsListComponent,
    CreateOrEditSubmittalsRegistryComponent,
    CreateOrEditSubmittalsItemComponent,
    SubmittalsWorkflowComponent,
    RfisWrapperComponent,
    IssuesTabComponent,
    MultiSectionFilterComponent,
    SortDropdownComponent,
    RfisListComponent,
    CreateOrEditRfisItemComponent,
    RfisWorkflowComponent,
    SampleRecordsWrapperComponent,
    SampleRecordsListComponent,
    CreateOrEditSampleRecordComponent,
    EmbeddedSampleRecordsComponent,
    SampleLocationPopupComponent,
    SampleTestEntryComponent,
    RfiSummaryComponent,
    SubmittalsSummaryComponent,
    RfisSubmittalsCombinedComponent,
    ChangeOrderTabWrapperComponent,
    CopyDailyReportComponent,
    WorkdayDetailsWrapperComponent,
    WorkdaySummaryComponent,
    CreateExternalTestComponent,
    ExternalTestDetailsWrapperComponent,
    ExternalTestDetailsComponent,
    CancelTestDialogComponent,
    ExternalTestDetailsExpandableBlockComponent,
    ExternalTestRequestDetailsComponent,
    ExternalTestScheduleDetailsComponent,
    ExternalTestRecordLabTestDetailsComponent,
    ExternalTestReportDetailsComponent,
    ExternalTestResultDetailsComponent,
    DocumentsWrapperComponent,
    DrawingsWrapperComponent,
    DrawingsRegisterComponent,
    DrawingUploadDialogComponent,
    DrawingPublishDialogComponent,
    DrawingsAsBuiltComponent,
    DrawingExportDialogComponent,
    DrawingSetReviewComponent,
    DrawingSetPagePanelComponent,
    DrawingSetPageViewerComponent,
    DrawingSheetViewerComponent,
    DrawingSheetEditPanelComponent,
    DrawingCompareOverlayComponent,
    DrawingCompareComponent,
    DrawingCarryForwardComponent,
    DrawingPlaceDialogComponent,
    DocumentsTableComponent,
    CreateNewFolderComponent,
    EditNameComponent,
    WarrantyWrapperComponent,
    WarrantySettingsComponent,
    WarrantyClaimsListComponent,
    WarrantyClaimDetailComponent,
    WarrantyClaimFormComponent,
    WarrantySettingsFormComponent,
    WarrantyTasksComponent,
    WarrantyTasksListComponent,
    WarrantyPackagesListComponent,
    WarrantyPackageFormComponent,
    WarrantyPackageDetailComponent,
    WarrantyStateDiagramComponent,
    PunchlistWrapperComponent,
    PunchlistSettingsComponent,
    PunchlistSettingsFormComponent,
    PunchlistItemsListComponent,
    PunchlistItemFormComponent,
    PunchlistItemDetailComponent,
    MappedReportListPageComponent,
    MappedReportViewerPageComponent,
    MappedReportPdfPaneComponent,
    MappedReportMapPaneComponent,
    DailyDiaryDayComponent,
    CreateDailyDiaryComponent,
    ProjectDiariesWrapperComponent,
    DailyDiaryDetailComponent,
    DailyDiaryFormComponent,
    DailyDiaryFiltersComponent,
    MgvwRecordsWrapperComponent,
    MgvwRecordsListComponent,
    CreateOrEditMgvwRecordComponent,
    RiskRegisterWrapperComponent,
    RiskRegisterListComponent,
    RiskHeatMapComponent,
    RiskDetailPanelComponent,
    RiskFormComponent,
    RiskConfigDialogComponent,
    RiskImportDialogComponent,
    RiskExportDialogComponent,
    RiskUpdatesTimelineComponent,
    RiskUpdateFormComponent,
    RiskScoreChipComponent,
    RiskCommentDialogComponent,
    RiskConvertDialogComponent,
  ],
  imports: [
  CommonModule,
    // W75: standalone, shared with the record Location dialog's Drawing tab
    SheetZoomControlsComponent,
    // The drawings sub-pages' detail header (Figma 33128:76594)
    DrawingsPageHeaderComponent,
    ProjectsRoutingModule,
    SharedModule,
    MaterialModule,
    ReportMapDataExportComponent,
    StoreModule.forFeature('sitenotes.projects', reducer),
    EffectsModule.forFeature([ProjectsEffects]),
    FormsModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    ProjectModule,
    SubContractorModule,
    CdkConnectedOverlay,
    CdkOverlayOrigin,
    MatTooltipModule,
    OverlayModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatIconModule,
    SubmenuDirectionDirective,
    MapControlsComponent, // Standalone component for basemaps and zoom controls
    NoLocationBadgeComponent, // Standalone component for no-location badges
    DrawingLinkedPanelComponent,
  ],
  providers: [
    // The record forms the Drawings viewer's Add to opens (a token keeps them out of the viewer's imports)
    {
      provide: DRAWING_ADD_TO_PANELS,
      useValue: { issue: IssueDetailsWrapperComponent, rfi: CreateOrEditRfisItemComponent, punch: PunchlistItemFormComponent },
    },
    // Place on map and the map layer review that publishes it (ArcGIS stays out of the viewer's imports)
    { provide: DRAWING_MAP_PANELS, useValue: { place: DrawingPlaceDialogComponent, layer: CreateOrEditMapLayerComponent } },
    // Provide custom DateAdapter at module level for title case month names
    {
      provide: DateAdapter,
      useClass: CustomCalendarDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MAP_CALENDAR_DATE_FORMATS,
    },
  ],
})
export class ProjectsModule {
}
